import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CloudTwoToneSvg from "@ant-design/icons-svg/es/asn/CloudTwoTone";
import AntdIcon from "../components/AntdIcon";
var CloudTwoTone = function CloudTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CloudTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CloudTwoTone.displayName = 'CloudTwoTone';
}
export default /*#__PURE__*/React.forwardRef(CloudTwoTone);